import { createConsumer, type Consumer } from '@rails/actioncable'

let consumer: Consumer | null = null
let consumerUrl: string | null = null

const toWebSocketProtocol = (protocol: string): string => {
  if (protocol === 'http:') return 'ws:'
  if (protocol === 'https:') return 'wss:'
  return protocol
}

const getActionCableBaseUrl = (): URL | null => {
  const configuredUrl = import.meta.env.VITE_APP_ACTIONCABLE_URL?.trim()

  if (configuredUrl) {
    const url = new URL(configuredUrl)
    url.protocol = toWebSocketProtocol(url.protocol)
    return url
  }

  const apiEndpoint = import.meta.env.VITE_APP_API_ENDPOINT?.trim()
  if (!apiEndpoint) return null

  const url = new URL(apiEndpoint)
  url.protocol = toWebSocketProtocol(url.protocol)
  url.pathname = '/cable'
  url.search = ''
  url.hash = ''
  return url
}

const buildAuthenticatedCableUrl = (token: string): string | null => {
  const baseUrl = getActionCableBaseUrl()
  if (!baseUrl) return null

  baseUrl.searchParams.set('token', token)
  baseUrl.searchParams.set('app_id', 'pas')
  return baseUrl.toString()
}

export const disconnectActionCable = () => {
  if (!consumer) return

  consumer.disconnect()
  consumer = null
  consumerUrl = null
}

export const syncActionCableAuth = (token: string | null): Consumer | null => {
  if (!token) {
    disconnectActionCable()
    return null
  }

  const nextUrl = buildAuthenticatedCableUrl(token)
  if (!nextUrl) {
    disconnectActionCable()
    return null
  }

  if (consumer && consumerUrl === nextUrl) {
    return consumer
  }

  disconnectActionCable()
  consumer = createConsumer(nextUrl)
  consumerUrl = nextUrl
  return consumer
}

export const getActionCableConsumer = (): Consumer | null => consumer
